/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

// eslint-disable-next-line react/prefer-stateless-function
class ButtonConfirmPopUp extends Component {
  render() {
    return (
      <React.Fragment>
        <div
          aria-labelledby="myModalLabel"
          className="modal fade"
          id={this.props.id}
          role="dialog"
          tabIndex="-1"
          style={{ display: 'none' }}
        >
          <div className="modal-dialog modal-gray modal-sm">
            <div className="modal-content">
              <div className="modal-header text-center">
                <a
                  aria-label="Close"
                  className="close close-black"
                  data-dismiss="modal"
                  href=""
                />
                <i className="fa fa-exclamation-triangle modal-icon" />
                <h4 className="modal-title">
                  <strong>{t('Подтверждение')}</strong>
                </h4>
              </div>
              <div
                className="modal-body text-center"
                style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
              >
                <p>
                  {this.props.confirmText
                    ? this.props.confirmText
                    : t('Вы уверены, что хотите сохранить изменения?')}
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-muted"
                  data-dismiss="modal"
                  type="button"
                >
                  {t('Отмена')}
                </button>
                <button
                  className="btn btn-primary"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.props.handleConfirmSuccess()}
                >
                  {this.props.buttonSuccessTitle
                    ? this.props.buttonSuccessTitle
                    : t('Сохранить')}
                </button>
              </div>
            </div>
          </div>
        </div>
        <a
          data-toggle="modal"
          href={`#${this.props.id}`}
          className={this.props.aClass}
          style={this.props.aStyles}
        >
          {this.props.children}
        </a>
      </React.Fragment>
    );
  }
}

ButtonConfirmPopUp.defaultProps = {
  type: 'button',
  aClass: '',
  aStyles: {},
  buttonSuccessTitle: undefined,
  confirmText: undefined
};

ButtonConfirmPopUp.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  aClass: PropTypes.string,
  aStyles: PropTypes.shape(),
  buttonSuccessTitle: PropTypes.string,
  confirmText: PropTypes.string,
  handleConfirmSuccess: PropTypes.func.isRequired
};

export default ButtonConfirmPopUp;



// WEBPACK FOOTER //
// ./src/components/Common/Buttons/ButtonConfirmPopUp/ButtonConfirmPopUp.js